export const DIGITS_SEARCH_MASK = '9*';
export const PHONE_EXTENSION_MASK = '9999999';
export const PHONE_MASK = '(000) 000-0000';
export const ZIP_MASK = '00000||00000-0000';
